// ============================================================================
// browser-fetch-service-mod -- Mod 定义
//
// 在浏览器环境中提供 IFetchService 实现（基于原生 fetch）。
// ============================================================================
import { FETCH_SERVICE_INTERFACE_TAG } from '@hvsin/fetch-contracts';
/**
 * 浏览器环境下的 Fetch 服务
 */
export class BrowserFetchService {
    async fetch(url, options) {
        const response = await globalThis.fetch(url, {
            method: options?.method ?? 'GET',
            headers: options?.headers,
            body: options?.body,
        });
        return {
            status: response.status,
            ok: response.ok,
            json: () => response.json(),
            text: () => response.text(),
        };
    }
}
export const browserFetchServiceMod = {
    name: 'browser-fetch-service',
    serviceDefs: [
        {
            serviceTag: 'fetchService',
            serviceImpl: BrowserFetchService,
            serviceInterfaceTag: FETCH_SERVICE_INTERFACE_TAG,
            dependencies: [],
        },
    ],
};
//# sourceMappingURL=mod.js.map